'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosComposeOutline = function IoIosComposeOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.8 32.5v-16.2l1.2-1.3v18.8h-25v-23.8h20l-1.2 1.3h-17.5v21.2h22.5z m-10.2-10.3l13.4-13.4 0.8 0.9-14 14.1h-2.5v-2.5l14-14.1 0.9 0.9-13.4 13.3z m16.1-15.9c0.1 0.2 0.3 0.4 0.3 0.7s-0.2 0.6-0.3 0.8l-0.9 1-2.5-2.5 0.9-1c0.2-0.1 0.5-0.3 0.8-0.3s0.5 0.2 0.8 0.3z' })
        )
    );
};

exports.default = IoIosComposeOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-compose-outline.js
// module id = 2164
// module chunks = 0